<template>
  <!-- :class="`${isPlay ? 'container-section-playing' : 'container-section'} ${isMobile ? 'my-2 px-5 py-2' : 'px-10'}`" -->
  <v-card
    :class="`${isMobile ? 'pa-0' : 'pa-0'} ${isPlay ? 'container-section-playing' : 'container-section'} ${
      this.totalSectionList && this.totalSectionList.length > 1 ? 'multi-section' : 'one-section'
    } ${'section' + this.sectionIndex}`"
    color="transparent"
    tile
    flat
    :style="
      (currentClip.clipType === 'embed'
        ? $vuetify.breakpoint.width < 1263
          ? 'height: calc(100vh - 125px) !important'
          : ''
        : '',
      isInIframe ? 'padding: 0 !important' : '')
    "
  >
    <!-- <div v-show="$vuetify.breakpoint.width < 960 && !isInIframe" id="dummyPadding" ref="dummyPadding"></div> -->
    <div
      v-if="isShowContents"
      id="wrapMeeting"
      ref="wrapMeeting"
      :style="$vuetify.breakpoint.width < 960 ? 'padding-bottom: 50px' : ''"
    >
      <div
        :class="isInIframe ? 'inIframe' : $vuetify.breakpoint.width < 960 ? 'split-mobile split' : 'split'"
        :style="
          this.totalSectionList && this.totalSectionList.length > 1
            ? 'height: calc(100vh - 90px)'
            : 'height: calc(100vh - 55px)'
        "
      >
        <div
          id="firstPanel"
          :class="
            isInIframe
              ? 'panel-inIframe-left'
              : $vuetify.breakpoint.width < 960
              ? 'panel-mobile-left first-panel'
              : 'panel first-panel'
          "
          style="background-color: #1d292f"
        >
          <add-clip-card
            v-if="!isInIframe"
            :firstPanelisSmall="firstPanelisSmall"
            style="margin-top: 15px"
          ></add-clip-card>
          <div
            :class="
              isInIframe
                ? hidePlayList
                  ? 'wrap-container-list isInIframe hidePlayList'
                  : upHere
                  ? 'wrap-container-list isInIframe upHere'
                  : 'wrap-container-list isInIframe notUpHere'
                : 'wrap-container-list'
            "
          >
            <div
              class="play-list-container"
              ref="playList"
              :style="isInIframe ? 'width: 100%; display: inline-block' : ''"
              @mouseleave="resetHoverListItem"
            >
              <div ref="playListInner" class="inner-play-list" :style="isInIframe ? 'padding-bottom: none' : ''">
                <div
                  v-for="(item, index) in clipList"
                  :key="index"
                  :class="firstPanelisSmall ? 'firstPanelisSmall' : 'firstPanelisNotSmall'"
                  @mouseover="hoverListItem(item, index)"
                  @click="showMobileSideList"
                >
                  <play-list-item
                    :key="index"
                    :clipIndex="index"
                    :cardItem="item"
                    :sectionIndex.sync="sectionIndex"
                    cardType="list"
                    @selectClip="selectClip"
                    @refreshData="refreshData"
                    :firstPanelisSmall="firstPanelisSmall"
                  ></play-list-item>
                </div>
              </div>
              <play-list-detail
                v-if="hoveredItem && hoveredIndex >= 0 && isShowListDetail"
                :cardItem="hoveredItem"
                :key="hoveredIndex"
                :clipIndex="hoveredIndex"
                :sectionIndex.sync="sectionIndex"
                cardType="list"
              ></play-list-detail>
            </div>
          </div>
          <help-support
            v-if="!isInIframe && $vuetify.breakpoint.width >= 960"
            :firstPanelisSmall="firstPanelisSmall"
            style=""
          ></help-support>
          <v-btn
            v-if="$vuetify.breakpoint.width < 960 && !isInIframe && mobileSideList"
            plain
            class="mr-3 btn-mobile-side-list"
            @click="showMobileSideList"
          >
            <span class="material-icons-round white--text" translate="no">
              {{ 'view_sidebar' }}
            </span>
          </v-btn>
        </div>
        <div
          id="secondPanel"
          ref="secondPanel"
          :class="
            isInIframe
              ? 'panel-inIframe-center'
              : $vuetify.breakpoint.width < 960
              ? 'panel-mobile-center second-panel'
              : 'panel second-panel'
          "
          style="background-color: #1d292f"
        >
          <div
            class="wrap-player"
            :style="
              !isInIframe
                ? $vuetify.breakpoint.width < 960
                  ? 'height: 100%; overflow-y: hidden !important'
                  : this.totalSectionList && this.totalSectionList.length > 1
                  ? 'height: calc(100vh - 149px)'
                  : 'height: calc(100vh - 114px)'
                : 'height: 0'
            "
          >
            <video-player
              v-if="isNotEmpty && !isLastClip"
              id="videoComponent"
              ref="videoComponent"
              :sectionIndex.sync="sectionIndex"
              :options.sync="videoOptions"
              :allEmojiList.sync="allEmojiList"
              :localFeedbackEmoji.sync="localFeedbackEmoji"
              @setFullScreen="setFullScreen"
              @feedbackPageEmoji="feedbackPageEmojiEmit"
              @hideComment="hideCommentChange"
              @hidePlayList="hidePlayListChange"
              :upHere.sync="upHere"
              :class="isInIframe ? 'container-video container-embed-video' : 'container-video'"
            />
            <detail-empty v-else-if="isLoaded || isLastClip" @refreshData="refreshData"></detail-empty>
            <div
              v-if="isNotEmpty && !isInIframe && !isLastClip && showTitleNote"
              :class="isInIframe ? 'container-note-and-comment isInIframe' : 'container-note-and-comment'"
            >
              <detail-note
                v-if="!isInIframe && !isLastClip && showTitleNote"
                :sectionIndex.sync="sectionIndex"
                :sectionClipIndex.sync="sectionClipIndex"
                @refreshData="refreshData"
              />
            </div>
          </div>

          <div
            v-if="!isInIframe"
            class="wrap-container-button"
            :style="isLastClip || isTemplateClip ? 'justify-content: end' : 'justify-content: space-between'"
          >
            <div class="d-flex" style="align-items: center">
              <div v-if="$vuetify.breakpoint.width < 960" style="width: 40px"></div>
              <detail-emoji-feedback
                v-if="isNotEmpty && !isInIframe && !isLastClip && !isTemplateClip"
                @emojiList="emojiList"
                :feedbackPageEmoji.sync="feedbackPageEmoji"
              ></detail-emoji-feedback>
            </div>
            <v-btn
              v-if="$vuetify.breakpoint.width < 960 && !isInIframe && !mobileSideList"
              plain
              class="mr-3 btn-mobile-side-list"
              @click="showMobileSideList"
            >
              <span class="material-icons-round white--text" translate="no">
                {{ 'view_sidebar' }}
              </span>
            </v-btn>
            <detail-button :sectionIndex.sync="sectionIndex" :sectionClipIndex.sync="sectionClipIndex" />
          </div>
        </div>
        <div
          id="thirdPanel"
          :class="
            isInIframe
              ? 'panel-inIframe-right'
              : $vuetify.breakpoint.width < 960
              ? 'panel-mobile-right third-panel'
              : 'panel third-panel'
          "
          style="background-color: #1d292f"
        >
          <div v-if="isNotEmpty && !isLastClip" style="position: relative; padding: 0px 5px">
            <v-tabs
              v-if="!isInIframe"
              v-model="tab"
              class="my-3"
              background-color="transparent"
              color="white"
              grow
              dark
              height="30"
              hide-slider
              :style="emittedSummary === 'nonTarget' && emittedTranscript === 'nonTarget' ? 'display: none' : ''"
            >
              <v-tab key="summary" :disabled="isSummaryDisabled">
                {{ $t('summary') }}
              </v-tab>
              <v-tab key="transcript" :disabled="isTranscriptDisabled">
                {{ $t('transcript') }}
              </v-tab>
              <v-tab key="comment">
                {{ $t('comment') }}
                <span class="ml-1 comment-length">
                  {{ this.commentsLength }}
                </span>
              </v-tab>
            </v-tabs>

            <v-divider
              dark
              :style="emittedSummary === 'nonTarget' && emittedTranscript === 'nonTarget' ? 'display: none' : ''"
            ></v-divider>

            <v-tabs-items v-model="tab">
              <v-tab-item key="summary" :eager="true">
                <v-card flat style="background-color: transparent">
                  <detail-summary @emitSummary="emitSummary"></detail-summary>
                </v-card>
              </v-tab-item>
              <v-tab-item key="transcript" :eager="true">
                <v-card flat style="background-color: transparent">
                  <detail-transcript @emitTranscript="emitTranscript"></detail-transcript>
                </v-card>
              </v-tab-item>
              <v-tab-item key="comment" :eager="true">
                <div
                  v-if="!isInIframe"
                  :style="
                    $vuetify.breakpoint.width >= 960
                      ? 'position: sticky; top: 0px; background-color: #1d292f; z-index: 2; padding: 20px 0 5px 0'
                      : 'padding: 10px 0 0 0'
                  "
                >
                  <detail-comment-input v-if="!isInIframe" :sectionIndex.sync="sectionIndex" :tabIndex.sync="tab" />
                </div>
                <div
                  v-show="hidePlayList"
                  :class="
                    isInIframe
                      ? hideComment
                        ? 'wrap-container-comment isInIframe hideComment'
                        : 'wrap-container-comment isInIframe showComment'
                      : 'wrap-container-comment'
                  "
                >
                  <detail-comment @commentsLength="commentsLengthEmit" :tabIndex.sync="tab" :upHere.sync="upHere" />
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
    </div>

    <!-- Chronological Follow Up Card -->
    <v-row v-else-if="mtInfo.mtType === 'chronological'" no-gutters>
      <!-- Empty 화면 -->
      <v-col cols="12">
        <detail-empty v-if="isLoaded"></detail-empty>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import PlayListItem from '@/views/meeting/component/PlayListItem'
import VideoPlayer from '@/views/meeting/component/VideoPlayer'
import AddClipCard from '@/views/meeting/component/AddClipCard'
import HelpSupport from '@/views/meeting/component/HelpSupport'
import DetailEmpty from '@/views/meeting/component/detail/DetailEmpty'
import DetailComment from '@/views/meeting/component/detail/DetailComment'
import DetailEmojiFeedback from '@/views/meeting/component/detail/DetailEmojiFeedback'
import DetailButton from '@/views/meeting/component/detail/DetailButton'
import { isMobile, setFullScreen } from '@/common/lib/strLib'
import DetailNote from '@/views/meeting/component/detail/DetailNote'
import { mapState, mapGetters } from 'vuex'
import DetailCommentInput from './DetailCommentInput.vue'
import { getCommentList, getPublicCommentList } from '@/services/commentApi'
import Split from 'split.js'
import PlayListDetail from '@/views/meeting/component/PlayListDetail'
import DetailSummary from '@/views/meeting/component/detail/DetailSummary'
import DetailTranscript from '@/views/meeting/component/detail/DetailTranscript'

export default {
  metaInfo() {
    return {
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `${this.currentClip.clipTitle}`,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: `${this.currentClip.clipThumbsUrl}`,
        },
        {
          property: 'og:description',
          content: `${this.currentClip.clipNote}`,
        },
      ],
    }
  },
  name: 'DetailVideo',
  components: {
    DetailComment,
    AddClipCard,
    PlayListItem,
    VideoPlayer,
    DetailEmpty,
    DetailNote,
    DetailButton,
    DetailCommentInput,
    DetailEmojiFeedback,
    HelpSupport,
    PlayListDetail,
    DetailSummary,
    DetailTranscript,
  },
  props: ['isLoaded', 'sectionIndex', 'sectionInfo', 'upHere'],
  data() {
    return {
      videoOptions: {
        // fluid: true,
        // crossorigin: 'anonymous',
        // autoplay: true,
        aspectRatio: '16:9',
        preload: 'auto',
        controls: false,
        playsinline: true,
        playbackRates: [2.0, 1.75, 1.5, 1.25, 1.0, 0.75, 0.5],
        html5: {
          nativeTextTracks: false,
        },
        textTrackSettings: false,
      },
      sectionClipIndex: 0,
      allEmojiList: [],
      localFeedbackEmoji: [],
      feedbackPageEmoji: [],
      hideComment: true,
      hidePlayList: true,
      hoveredItem: [],
      hoveredIndex: '',
      isShowListDetail: false,
      instance: [],
      firstPanelisSmall: false,
      commentsLength: 0,
      tab: 0,
      items: ['Appetizers', 'Entrees', 'Deserts', 'Cocktails'],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      mobileSideList: false,
      emittedSummary: '',
      emittedTranscript: '',
    }
  },
  created() {
    this.sectionClipIndex = this.sectionIndex === this.storeSectionIndex ? this.storeClipIndex : 0
  },
  mounted() {
    if (!this.isInIframe) {
      this.initSplit()
      this.initGutter()
    } else {
      // window.Intercom('shutdown')
    }
    this.setSectionScroll()
    if (this.$refs.videoComponent) {
      if (this.$refs.videoComponent || this.$refs.videoComponent.$el) {
        this.resizeObserver = new ResizeObserver(this.mobileLayout)
        this.resizeObserver.observe(this.$refs.videoComponent.$el)
        this.mobileLayout()
      }
    }

    document.addEventListener('keydown', this.keyEvent)

    if (this.isInIframe) {
      this.getCommentList(false)
    }
    this.setDefaultTab()
  },
  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.videoComponent.$el)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  updated() {
    this.mobileLayout()
  },
  methods: {
    commentsLengthEmit(val) {
      this.commentsLength = val
      // console.log(this.commentsLength)
    },
    emitSummary() {
      //   this.emittedSummary = val
      //   if (val === 'nonTarget') {
      //     this.tab = 2
      //   } else if (val === 'fail') {
      //     this.tab = 2
      //     if (this.emittedTranscript !== 'fail') this.tab = 1
      //   } else {
      //     this.tab = 1
      //   }
    },
    emitTranscript() {
      //   this.emittedTranscript = val
      //   if (val === 'nonTarget') {
      //     this.tab = 2
      //   } else if (val === 'fail') {
      //     this.tab = 2
      //     if (this.emittedSummary !== 'fail') this.tab = 0
      //   } else {
      //     this.tab = 1
      //   }
    },
    isFirstPanelisSmall(value, percent) {
      let oldVal = this.firstPanelisSmall

      if (percent && Number(value) < 5) {
        this.firstPanelisSmall = true
      } else if (!percent && Number(value) < 100) {
        this.firstPanelisSmall = true
      } else {
        this.firstPanelisSmall = false
      }

      if (this.firstPanelisSmall && this.firstPanelisSmall !== oldVal) {
        this.instance.setSizes([0, 70, 30])
      }
    },
    initSplit() {
      let firstSection = this.sectionClass + ' #wrapMeeting .split .first-panel'
      let secondSection = this.sectionClass + ' #wrapMeeting .split .second-panel'
      let thirdSection = this.sectionClass + ' #wrapMeeting .split .third-panel'
      let gutter = this.sectionClass + ' #wrapMeeting .split .gutter'

      const firstSectionElem = document.querySelector(firstSection)
      const secondSectionElem = document.querySelector(secondSection)
      const thirdSectionElem = document.querySelector(thirdSection)

      if (firstSectionElem && secondSectionElem && thirdSectionElem && document.querySelectorAll(gutter).length === 0) {
        let initSizes
        if (localStorage.getItem('split-sizes')) {
          initSizes = localStorage
            .getItem('split-sizes')
            .split(',')
            .map(function (item) {
              return parseInt(item, 10)
            })
          if (initSizes[0] + initSizes[1] + initSizes[2] !== 100) {
            initSizes[1] = 100 - (initSizes[0] + initSizes[2])
          }
          // this.isFirstPanelisSmall(localStorage.getItem('split-sizes').split(',')[0])
        } else {
          initSizes = [0, 70, 30]
          localStorage.setItem('split-sizes', initSizes)
        }

        this.instance = Split([firstSection, secondSection, thirdSection], {
          gutterSize: 8,
          snapOffset: 60,
          sizes: initSizes,
          minSize: [50, 300, 300],
          maxSize: [500, Infinity, 600],
          onDrag: function (sizes) {
            localStorage.setItem('split-sizes', sizes)
            this.isFirstPanelisSmall(document.querySelector(firstSection).offsetWidth, false)
          }.bind(this),
        })

        this.isFirstPanelisSmall(initSizes[0], true)
      }
    },
    initGutter() {
      let gutter = this.sectionClass + ' #wrapMeeting .split .gutter'
      let gutters = document.querySelectorAll(gutter)

      for (let i = 0; i < gutters.length; i++) {
        gutters[0].style.textAlign = 'right'
        gutters[i].appendChild(document.createElement('div'))
      }
    },
    firstPanelWidth() {
      // console.log(this.instance)
    },
    keyEvent(e) {
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        // C : 코멘트에 포커스
        if (!e.ctrlKey && !e.metaKey && e.keyCode === 67) {
          //커멘트 탭 이동 및 스타일링 추가
          this.$store.dispatch('setBoxDrawn', true)
          this.tab = 2
          document.querySelector('#commentInputBoxId').focus()
          e.preventDefault()
          // D : 플레이 리스트에 마우스 올린 상태라면 세부 정보 표시/닫기
        } else if (!e.ctrlKey && !e.metaKey && e.keyCode === 68) {
          if (this.hoverListItem && this.hoveredIndex >= 0) this.isShowListDetail = !this.isShowListDetail
          e.preventDefault()
        }
      } else {
        // Esc : 코멘트에서 포커스 아웃
        if (e.keyCode === 27) {
          document.querySelector('#commentInputBoxId').blur()
          e.preventDefault()
        }
      }
    },
    hoverListItem(item, index) {
      this.hoveredItem = item
      this.hoveredIndex = index
    },
    resetHoverListItem() {
      this.hoveredItem = null
      this.hoveredIndex = null
      this.isShowListDetail = false
    },
    hideCommentChange(val) {
      this.hideComment = val
    },
    hidePlayListChange(val) {
      this.hidePlayList = val
    },
    mobileLayout() {
      const videoComponent = this.$refs.videoComponent
      const wrapMeeting = this.$refs.wrapMeeting
      const dummyPadding = this.$refs.dummyPadding
      const splitSizes = localStorage.getItem('split-sizes')

      if (videoComponent && videoComponent.$el) {
        let videoHeight = videoComponent.$el.offsetHeight

        if (this.isInIframe) {
          wrapMeeting.style.height = 'auto'
          this.firstPanelisSmall = false
        } else if (this.$vuetify.breakpoint.width < 960) {
          const mql = window.matchMedia('(orientation: landscape)')
          if (mql.matches || !this.isNotEmpty || this.isLastClip) {
            wrapMeeting.style.paddingTop = '0px'
          } else {
            wrapMeeting.style.paddingTop =
              videoHeight + (this.totalSectionList && this.totalSectionList.length > 1 ? 35 : 0) + 'px'
          }
          this.firstPanelisSmall = false
        } else {
          wrapMeeting.style.height = 'auto'
          if (splitSizes) {
            let firstSection = this.sectionClass + ' #wrapMeeting .split .first-panel'
            this.isFirstPanelisSmall(document.querySelector(firstSection).offsetWidth, false)
          }
        }
      } else {
        if (wrapMeeting) wrapMeeting.style.height = '100%'
        if (dummyPadding) dummyPadding.style.height = '0px'
      }
    },
    showMobileSideList() {
      const sideList = document.querySelector('.panel-mobile-left')
      if (sideList) {
        sideList.classList.toggle('isActive')
        this.mobileSideList = !this.mobileSideList
      }
    },
    feedbackPageEmojiEmit(val) {
      this.feedbackPageEmoji = val
    },
    setFullScreen() {
      setFullScreen(this.$refs.videoComponent.$el)
    },
    showHideListBtns() {
      let container = document.getElementsByClassName('container-list-and-button')[this.sectionIndex]
      container.classList.toggle('hide')
    },
    keyDown(e) {
      if (e.target.nodeName !== 'TEXTAREA' && e.target.nodeName !== 'INPUT') {
        let seekTime = this.$store.getters.seekTime
        // Arrow Left
        if (e.which === 37 && seekTime !== undefined && seekTime !== null) {
          this.$store.dispatch('setTimeStampSeekTime', seekTime > 5 ? seekTime - 5 : 0)
          this.$store.dispatch('setIsRequestSetSeekTime', true)
        }
        // Arrow Right
        if (e.which === 39 && seekTime !== undefined && seekTime !== null) {
          let duration = this.currentClip.clipDuration
          let time = seekTime + 5
          if (duration !== undefined && duration !== null && time < duration) {
            this.$store.dispatch('setTimeStampSeekTime', time)
            this.$store.dispatch('setIsRequestSetSeekTime', true)
          }
        }
        // Space
        if (e.which === 32) {
          e.preventDefault()
          if (this.sectionIndex === this.storeSectionIndex && this.isShowingPlayer) {
            this.$store.dispatch('setIsPlayerPause', !this.$store.getters.isPlayerPause)
          }
        }
      }
    },
    selectClip(clip, clipIndex) {
      // Last Clip 바로 전 클립을 선택할 경우 클릭이 안먹는 이슈가 있어서 추가
      if (this.isLastClip && this.clipList.length - 1 === clipIndex) this.$store.dispatch('beforeClip')
      else {
        this.sectionClipIndex = clipIndex
        this.$store.dispatch('changeCurrentClip', {
          clipIndex: clipIndex,
          sectionIndex: this.sectionIndex,
          currentClip: clip,
          timeStampSeekTime: 0,
        })
        // 스크롤 유지를 위해.
        localStorage.setItem('currentClip', JSON.stringify(this.currentClip))
      }
    },
    refreshData() {
      this.$emit('refreshData')
    },
    emojiList({ data1, data2 }) {
      this.allEmojiList = data1
      this.localFeedbackEmoji = data2
    },
    setSectionScroll() {
      setTimeout(() => {
        // 같은 미팅에서 Refresh 작업등이 이루어 졌을 시 기존 Scroll로 이동시켜준다
        try {
          // let searchParams = new URLSearchParams(new URL(location.href).search)
          // let clipId = searchParams.get('clipId')

          // if (clipId && clipId !== null && clipId !== '') {
          let listScrollX = localStorage.getItem('scrollX')
          let listScrollY = localStorage.getItem('scrollY')
          let sectionScrollX = localStorage.getItem('sectionScrollX')
          let sectionScrollY = localStorage.getItem('sectionScrollY')
          if (
            this.$refs.list !== undefined &&
            this.$refs.list !== null &&
            listScrollX !== undefined &&
            listScrollY !== undefined &&
            listScrollX !== null &&
            listScrollY !== null
          )
            this.$refs.list.scrollTo({
              top: listScrollY,
              left: listScrollX,
            })

          if (
            sectionScrollX !== undefined &&
            sectionScrollY !== undefined &&
            sectionScrollX !== null &&
            sectionScrollY !== null
          )
            window.scrollTo({
              top: sectionScrollY,
              left: sectionScrollX,
            })

          // }
        } catch (e) {
          console.log(e)
        }
      }, 1)
    },
    setPlayListScroll() {
      // Scroll Event 변경 - Julian (jsyoon)
      // Dom Rending 후 작업이라 setTimeout 을 걸어주었음..
      setTimeout(() => {
        try {
          let currentItem = document.getElementsByClassName('isPlaying')
          let listScrollY = 0
          let listScrollX = 0

          if (this.$refs.playListInner !== undefined && this.$refs.playListInner !== null) {
            if (currentItem && currentItem !== null && currentItem.length > 0) {
              listScrollY = currentItem[0].offsetTop
              listScrollX = currentItem[0].offsetLeft

              let listHeight = this.$refs.playListInner.offsetHeight / 2 - currentItem[0].offsetHeight / 2
              let listWidth = this.$refs.playListInner.offsetWidth / 2 - currentItem[0].offsetWidth / 2

              listScrollY -= listHeight
              listScrollX -= listWidth
            }
            localStorage.setItem('scrollX', listScrollX)
            localStorage.setItem('scrollY', listScrollY)
            this.$refs.playListInner.scrollTo({
              top: listScrollY,
              left: listScrollX,
              behavior: 'smooth',
            })
          }
        } catch (e) {
          console.log()
        }
      }, 1)
    },
    async setCommentList(val) {
      await this.$store.dispatch('setCommentList', val)
    },
    async getCommentList() {
      // if (!isInfinityCall) {
      //   this.lastKey = null
      //   this.isBottom = false
      //   this.isFinish = false
      // }

      try {
        // if (this.isFinish) return true
        // let result = this.chkMtPublic
        //   ? await getPublicCommentList(this, this.currentMt.mtId, this.currentClip.clipId, undefined, this.lastKey)
        //   : await getCommentList(this, this.currentMt.mtId, this.currentClip.clipId, undefined, this.lastKey)
        let result =
          this.chkMtPublic && this.chkMtPublic['isPublic']
            ? await getPublicCommentList(this, this.currentMt.mtId, this.currentClip.clipId, undefined, undefined)
            : await getCommentList(this, this.currentMt.mtId, this.currentClip.clipId, undefined, undefined)

        this.$store.dispatch('setControlbarIconList', result.boxCommentList)

        if (result !== undefined && result !== null) {
          this.setCommentList([])
          let list = this.$store.getters.commentList
          // if (!isInfinityCall) this.setCommentList([])
          for (let comment of this.commentList) {
            list.push(comment)
          }

          this.setCommentList(list.concat(result.list))
          // this.commentList = this.commentList.concat(result.list)
          // if (result.lastKey && result.lastKey !== null) this.lastKey = result.lastKey
          // else {
          //   this.lastKey = null
          // }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$nextTick(() => {
          if (this.boxCommentComponent) {
            this.boxCommentComponent.filteredComments = this.controlbarIconList ? [...this.controlbarIconList] : []
          }
        })
        // this.isCommentListLoading = false
      }
    },
    setDefaultTab() {
      // Video 또는 Audio인가? + Upload는 아님
      if (this.isLastClip || this.isTemplateClip || this.currentClip.clipType == 'upload') {
        this.tab = 2 // upload 포함한 template 클립은 댓글 탭 + 나머지 disabled (computed의 isSummaryDisabled, isTranscriptDisabled에서 처리)
        // summarization 개발 이후 클립인가?
      } else if (
        this.currentClip['transcriptStatus'] === undefined &&
        this.currentClip['summaryStatus'] === undefined
      ) {
        this.tab = 2 // 댓글 탭
        // 둘 다 변환 중 (최초 올렸을 시점)
      } else if (this.currentClip['transcriptStatus'] === 0 && this.currentClip['summaryStatus'] === 0) {
        this.tab = 1 // 여기는 자막 탭
        // 요약이 없거나 실패했나?
      } else if (this.currentClip['summaryStatus'] !== 2 && this.currentClip['summaryStatus'] !== 3) {
        this.tab = 0 // 실패하지 않았으면 요약 탭
        // 댓글이 있나?
      } else if (this.commentList && this.commentList.length > 0) {
        this.tab = 2 // 댓글 탭
        // 자막이 있나?
      } else if (this.currentClip['transcriptStatus'] === 1) {
        this.tab = 1 // 자막 탭
        // 기본은 댓글 탭
      } else {
        this.tab = 2
      }
    },
  },
  computed: {
    showTitleNote() {
      return !this.isTemplateClip || this.currentClip.clipType === 'text' || this.currentClip.clipType === 'embed'
    },
    isSummaryDisabled() {
      const summaryStatus = this.currentClip['summaryStatus']

      return (
        summaryStatus === undefined ||
        summaryStatus === null ||
        (summaryStatus !== undefined && summaryStatus !== null && summaryStatus === 2) ||
        this.isLastClip ||
        this.isTemplateClip ||
        this.currentClip.clipType == 'upload'
      )
    },
    isTranscriptDisabled() {
      const transcriptStatus = this.currentClip['transcriptStatus']

      return (
        transcriptStatus === undefined ||
        transcriptStatus === null ||
        (transcriptStatus !== undefined && transcriptStatus !== null && transcriptStatus === 2) ||
        this.isLastClip ||
        this.isTemplateClip ||
        this.currentClip.clipType == 'upload'
      )
    },
    sectionClass() {
      return '.section' + this.sectionIndex
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
    kindOfEmbed() {
      return this.$route.query
    },
    calcHeightOfComment() {
      if (this.isMobile) {
        return `calc(100vh - ${this.$refs.videoComponent.$el.clientHeight}px)`
      } else {
        return '100%'
      }
    },

    isShowingPlayer() {
      let result = false
      if (this.totalSectionList && this.totalSectionList !== null && this.totalSectionList.length > 0 && !result) {
        let clipList = this.totalSectionList[this.sectionIndex].clipList
        if (clipList !== undefined && clipList !== null && clipList.length > 0) {
          let clip = this.totalSectionList[this.sectionIndex].clipList[this.storeClipIndex]
          if (clip)
            result =
              clip.clipType === 'screen' ||
              clip.clipType === 'face' ||
              clip.clipType === 'audio' ||
              clip.clipType === 'upload'
        }
      }
      return result
    },
    ...mapGetters([
      'currentClip',
      'totalSectionList',
      'isRequestSetSeekTime',
      'userInfo',
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'commentList',
      'seekTime',
      'clipIndex',
      'clipList',
      'chkMtPublic',
      'controlbarIconList',
      'currentMt',
      'boxDrawn',
      'selectedCh',
      'isExtensionClipUploadFinish',
      'wsClipCnt',
      'clickedSummaryCard',
      'isSummaryIconClicked',
      'clickCommentId',
      'isCommentIconClicked',
    ]),
    ...mapState({
      isMtOrganizer: (state) => {
        if (
          state &&
          state !== null &&
          state.auth &&
          state.auth !== null &&
          state.auth.currentMt &&
          state.auth.currentMt !== null &&
          state.auth.userInfo &&
          state.auth.userInfo !== null
        ) {
          return state.auth.currentMt.mtOrganizerUid === state.auth.userInfo.userId
        } else {
          return false
        }
      },
    }),
    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },
    isPlay() {
      if (
        this.mtInfo.mtType === 'chronological' &&
        this.clipList !== undefined &&
        this.clipList !== null &&
        this.clipList.length > 0
      )
        return this.clipList[0].clipId === this.currentClip.clipId
      else return false
    },
    clipList() {
      if (
        this.totalSectionList !== undefined &&
        this.totalSectionList !== null &&
        this.totalSectionList.length > 0 &&
        this.sectionIndex !== undefined &&
        this.sectionIndex !== null &&
        this.sectionIndex >= 0
      ) {
        return this.totalSectionList[this.sectionIndex].clipList
      }
      return []
      // return this.$store.getters.clipList
    },
    isShowContents() {
      return (
        this.mtInfo.mtType !== 'chronological' || (this.mtInfo.mtType === 'chronological' && this.clipList.length > 0)
      )
    },
    mtInfo() {
      return this.$store.getters.currentMt ?? {}
    },
    isPrivate() {
      return this.mtInfo && this.mtInfo !== null && this.mtInfo.mtPermission === 'private'
    },
    isNotEmpty() {
      return this.isLoaded && this.clipList !== undefined && this.clipList !== null && this.clipList.length > 0
    },
    stId() {
      if (
        this.totalSectionList !== undefined &&
        this.totalSectionList !== null &&
        this.totalSectionList.length > 0 &&
        this.sectionIndex !== undefined &&
        this.sectionIndex !== null &&
        this.sectionIndex >= 0
      )
        return this.totalSectionList[this.sectionIndex].stId
      else return undefined
    },
    isMobile() {
      return isMobile()
      // return true
    },
    storeSectionIndex() {
      return this.$store.getters.sectionIndex
    },
    storeClipIndex() {
      return this.$store.getters.clipIndex
    },
    isShowSectionTitle() {
      return (
        this.sectionInfo &&
        this.sectionInfo !== null &&
        this.mtInfo.mtType === 'topic' &&
        (this.isMtOrganizer || this.isSectionOrganizer || this.sectionInfo.stTitle !== '')
      )
    },

    isSectionOrganizer() {
      return (
        this.sectionInfo !== undefined &&
        this.sectionInfo !== null &&
        this.userInfo !== undefined &&
        this.userInfo !== null &&
        this.sectionInfo.stCreatorUid === this.userInfo.userId
      )
    },
    isLastClip() {
      return this.$store.getters.isLastClip && this.$store.getters.isLastClip !== null
    },
    isTemplateClip() {
      return (
        this.currentClip.clipType === 'text' ||
        this.currentClip.clipType === 'embed' ||
        this.currentClip.clipType === 'willFollowUp' ||
        this.currentClip.clipType === 'followUp' ||
        this.currentClip.clipType === 'poll'
      )
    },
  },
  watch: {
    isCommentIconClicked(val) {
      if (val) {
        this.tab = 2
      }
    },

    isSummaryIconClicked(val) {
      if (val) {
        this.tab = 0
      }
    },

    storeClipIndex() {
      if (this.sectionIndex === this.storeSectionIndex) this.setPlayListScroll()
    },
    storeSectionIndex: {
      deep: true,
      immediate: true,
      handler() {
        this.initSplit()
      },
    },
    isRequestSetSeekTime(isRequestSetSeekTime) {
      if (isRequestSetSeekTime && isRequestSetSeekTime !== null && this.sectionIndex == this.storeSectionIndex)
        this.setPlayListScroll()
    },
    currentClip() {
      this.setDefaultTab()
      this.$store.dispatch('setIsLastClip', false)
      if (this.sectionIndex === this.storeSectionIndex) this.sectionClipIndex = this.storeClipIndex
      this.$refs.secondPanel.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    // commentList(val) {
    //   if (val && val.length > 0) this.setDefaultTab()
    // },
    isLastClip(val) {
      if (val) {
        this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
        this.$store.dispatch('setIsPauseIcon', false)
      }
    },
  },
}
</script>

<style scoped>
.container-section,
.container-section-playing {
  width: 100vw;
}
.container-clip {
  display: flex;
  flex-direction: column;
  /* aspect-ratio: 16 / 9; */
}
.container-video-and-detail {
  display: flex;
  /* flex-direction: row; */
  /* height: calc(100% - 115px); */
}
.container-list-and-button {
  display: flex;
  flex-direction: row;
  height: 110px;
}
.container-video {
  flex: 1 1 auto;
  display: flex;
  /* background: rgb(31, 46, 53); */
  /* background: black; */
}
.container-video >>> video {
  background-color: rgb(31, 46, 53) !important;
}
.container-note-and-comment {
  display: flex;
  flex-direction: column;
  padding: 12px;
}
.wrap-container-comment {
  background-color: rgb(29, 41, 47) !important;
  padding: 0 1px;
  overflow-x: hidden;
  overflow-y: auto;
}
.container-player {
  display: block;
  position: relative;
  width: 100%;
}
.play-list-container {
  position: relative;
}
.inner-play-list {
  display: flex;
  flex-direction: column;
}
.fade {
  height: 100%;
  width: 30px;
  position: absolute;
  right: 0;
  background: -webkit-linear-gradient(left, rgba(31, 46, 53, 0) 0%, rgba(31, 46, 53, 1) 100%);
  z-index: 10;
}
.wrap-container-list {
  display: inline-block;
  position: relative;
  width: 100%;
  height: calc(100% - 100px);
  padding-left: 5px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 5px;
}
.wrap-container-list::-webkit-scrollbar {
  width: 0px;
}
.wrap-container-button {
  /* position: fixed; */
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  height: 50px;
  /* background-color: rgb(33, 52, 59); */
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.btn-container-list {
  display: none;
}
@media (max-width: 959px) {
  .container-section.multi-section,
  .container-section-playing.multi-section {
    max-height: none !important;
  }
  .container-clip {
    aspect-ratio: auto !important;
    display: block !important;
  }
  .container-section,
  .container-section-playing {
    height: none !important;
    max-height: none !important;
  }
  .container-video-and-detail {
    display: flex;
    flex-direction: column;
  }
  .container-video {
    max-height: none;
    height: none;
  }
  .play-list-container {
    width: 100%;
    border-radius: 15px;
    /* overflow-x: auto;
    overflow-y: hidden; */
  }
  .container-note-and-comment,
  .wrap-container-comment,
  .container-comment {
    height: auto;
    min-height: auto !important;
  }
  .container-note-and-comment {
    padding: 10px 10px 0 6px;
  }
  .container-list-and-button {
    height: 185px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 10px;
    flex-direction: column;
    background-color: rgb(19, 30, 33);
    z-index: 198;
    border-radius: 10px 10px 0 0;
    transition: all 0.3s;
  }
  .btn-container-list {
    display: inline-block;
    width: 45px;
    height: 45px !important;
    position: absolute;
    top: -40px;
    left: 15px;
    background-color: rgb(19, 30, 33) !important;
    border-radius: 4px 4px 0 0;
  }
  .container-list-and-button >>> .arrowdown {
    display: inline-block;
  }
  .container-list-and-button >>> .arrowup {
    display: none;
  }
  .container-list-and-button.hide >>> .arrowdown {
    display: none;
  }
  .container-list-and-button.hide >>> .arrowup {
    display: inline-block;
  }
  .hide {
    bottom: -115px;
    transition: all 0.3s;
  }
  .fade {
    display: none;
  }
  .wrap-container-button {
    position: fixed;
    bottom: 0;
    background-color: rgb(29, 41, 47) !important;
    z-index: 9999 !important;
    padding: 0 10px;
  }
}

.play-list-container-mobile {
  background: #21343b !important;
  border-radius: 10px;
  overflow-y: hidden !important;
}
.list-container {
  position: relative;
  height: 262px;
}
.list-container-mobile {
  position: relative;
}
/* width */
::-webkit-scrollbar {
  height: 5px;
}
@media screen and (max-width: 959px) and (orientation: portrait) {
  .multi-section .container-video {
    position: fixed;
    top: 90px;
    z-index: 9999;
    background-color: transparent;
  }
  .one-section .container-video {
    position: fixed;
    top: 55px;
    z-index: 9999;
    background-color: transparent;
  }
}

@media screen and (max-width: 959px) and (orientation: landscape) {
  .multi-section .container-video {
    position: relative;
    z-index: 9999;
    background-color: transparent;
  }
  .one-section .container-video {
    position: relative;
    z-index: 9999;
    background-color: transparent;
  }
}
@media (max-width: 959px) {
  .container-embed-video {
    position: relative !important;
    z-index: unset !important;
  }
  div.v-tabs.theme--dark.fixed {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 198;
  }
  .container-note-and-comment {
    z-index: 197;
  }
  .container-list-and-button {
    z-index: 199;
  }
}
.background-playlist {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.split {
  display: flex;
  flex-direction: row;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
.split-mobile {
  display: flex;
  flex-direction: column;
  position: relative;
  height: auto !important;
}
.inIframe {
  height: auto !important;
}
.inIframe .wrap-player {
  border: none;
}
.split >>> .gutter.gutter-horizontal {
  background-color: #1d292f;
  cursor: col-resize;
  transition: all 0.3s;
}
.split >>> .gutter.gutter-horizontal div {
  display: inline-block;
  width: 1px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  transition: all 0.3s;
}
.split >>> .gutter.gutter-horizontal:hover div {
  width: 3px;
  background-color: #586d79;
  transition: all 0.3s;
}
.split >>> .panel {
  overflow-x: hidden;
  overflow-y: overlay;
  padding: 4px 0 0 0;
}
.split >>> .third-panel {
  overflow-x: hidden;
  overflow-y: overlay;
  padding: 0px 4px 4px 0;
}
.split >>> .panel:first-of-type {
  overflow-x: hidden;
  overflow-y: hidden;
}
.split >>> .first-panel {
  position: relative;
  padding: 4px 0 0 0;
  min-width: 50px;
}
.split >>> .second-panel {
  overflow-y: hidden;
  padding: 4px 0 0 0;
}
.wrap-player {
  display: inline-block;
  width: calc(100% - 8px);
  overflow-x: hidden;
  overflow-y: auto !important;
  border-radius: 5px;
  border: 1px solid #141c20;
  margin-left: 4px;
}
.split-mobile >>> .panel-mobile-left {
  position: fixed;
  top: 0px;
  left: -300px;
  width: 300px !important;
  height: 100%;
  z-index: 999;
  transition: left 0.3s;
  border-right: 1px solid #586d79;
}
.split-mobile >>> .panel-mobile-left.isActive {
  left: 0px !important;
  transition: left 0.3s;
}
.split-mobile >>> .panel-mobile-center {
  position: relative;
  width: 100% !important;
  height: auto;
  z-index: 1;
}
.split-mobile >>> .panel-mobile-right {
  position: relative;
  width: 100% !important;
}
@media (max-width: 959px) {
  .split >>> .gutter.gutter-horizontal div {
    display: none;
  }
  .wrap-player {
    width: 100%;
    border: none;
    margin: 0px;
  }
  .split >>> .second-panel {
    padding: 0;
  }
}

.v-tab {
  text-transform: none;
  letter-spacing: 0;
  padding: 0 8px;
  background-color: #21343b;
  font-size: 13px;
  border-radius: 3px;
  margin: 0 2px;
}
.v-tab.v-tab--active {
  background-color: #31434f;
}
.v-tabs >>> .v-slide-group__prev {
  flex: 0 1 36px !important;
  min-width: 36px !important;
}
.v-tabs >>> .v-slide-group__next {
  flex: 0 1 36px !important;
  min-width: 36px !important;
}
.v-item-group.v-tabs-items {
  background-color: transparent;
  height: 100%;
}
.comment-length {
  font-size: 10px;
  border: 1px solid #96a7af;
  border-radius: 4px;
  padding: 0 3px;
}
.wrap-container-list.isInIframe {
  position: fixed;
  width: 100%;
  max-width: 350px;
  top: -5px;
  bottom: 0;
  right: 0;
  transition: opacity 0.3s;
}
.isInIframe.hidePlayList {
  height: calc(100%);
  opacity: 0;
  z-index: 0;
  pointer-events: none;
}
.isInIframe.upHere {
  height: calc(100% - 83px);
  opacity: 1;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.7);
}
.isInIframe.notUpHere {
  height: calc(100%);
  opacity: 1;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.7);
}

.inner-play-list .firstPanelisSmall {
  display: inline-block;
  width: 100%;
  margin: 5px 0;
}
.inner-play-list .firstPanelisNotSmall {
  display: inline-block;
  width: 100%;
  padding: 5px;
}
.btn-mobile-side-list {
  min-width: 36px;
  padding: 0;
  position: absolute;
  bottom: 7px;
  left: 10px;
}
.btn-mobile-side-list span {
  font-size: 17px;
  font-weight: 500;
  transform: rotate(180deg);
}

.wrap-container-comment.isInIframe.hideComment {
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 0;
  pointer-events: none;
}
.wrap-container-comment.isInIframe.showComment {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 10000;
}

.container-note-and-comment.isInIframe {
  position: absolute !important;
  width: 50%;
  height: calc(100% - 90px);
  right: -50%;
  z-index: 999;
}
</style>
